<template>
  <div class="customer-service-popup">
    <div class="customer-service-popup-title">
      <span>Besoin d’aide ?</span>
    </div>
    <span class="customer-service-popup-text"
      >Écrivez-nous à <a href="mailto:washi-app@latelier.co">washi-app@latelier.co</a></span
    >
    <div class="customer-service-popup-text">
      <span
        >Pour signaler un problème, pensez à inclure les éléments suivants (si possible), cela nous aide à répondre plus
        vite :</span
      >
      <ul>
        <li>Votre adresse e-mail Washi</li>
        <li>L’appareil et/ou le navigateur utilisé</li>
        <li>La date et l’heure de l’incident</li>
        <li>Une description du problème (quelles sont les étapes pour le reproduire ?)</li>
        <li>L’URL de la page concernée</li>
        <li>Une capture d’écran</li>
        <li>Le document ou dossier de compétences concerné</li>
      </ul>
    </div>
    <button class="secondary-button inverted button" @click="popupResolve">FERMER</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CustomerServicePopup',
  computed: {
    ...mapGetters(['popupResolve']),
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';
.customer-service-popup {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  max-width: min(90vw, 552px);
  .customer-service-popup-title {
    width: 100%;
    border-bottom: 2px solid colors.$light-blue-color;
    color: colors.$light-blue-color;
    text-transform: uppercase;
    padding: 1rem 0;

    > span {
      font-weight: bold;
      font-size: 1.1rem;
      line-height: 1.5rem;
    }
  }

  .customer-service-popup-text {
    font-weight: 400;
    font-size: 1.1rem;
    line-height: 1.5rem;

    > a {
      font-weight: bold;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .button {
    width: 9.3rem;
    font-weight: bold;

    &:hover {
      background-color: colors.$light-blue-color;
      color: white;
    }
  }
}
</style>
